import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Container from '../Container/Container';
import CancelIcon from '../CancelIcon/CancelIcon';
import Paragraph from '../Typography/Paragraph/Paragraph';
import styles from './ConfirmationText.module.scss';
const ConfirmationText = ({ text, closeModal, isClosed }) => {
    return (_jsx(_Fragment, { children: isClosed && (_jsx(Container, Object.assign({ className: styles.element }, { children: _jsxs("div", Object.assign({ className: 'd-flex justify-content-center' }, { children: [_jsx(Paragraph, { title: text }), _jsx(CancelIcon, { onClick: closeModal })] })) }))) }));
};
export default ConfirmationText;
